import groupBy from "lodash/groupBy";
import includes from "lodash/includes";
import some from "lodash/some";

const SHADES_PRODUCT_IDS = ["1", "2"];
const SINGLE_SIDE_COLOR_PRODUCT_IDS = ["3"];

export const formatSelectedItems = (items, products, locale, t) => {
  if (!items || !items.length) return [];

  return items
    .filter(({ product: { id } }) => some(products, { id: id }))
    .map(
      ({
        product,
        material,
        system,
        type,
        color,
        colorInterior,
        colorExterior,
        selectedShades,
        ...rest
      }) => {
        const item = {
          product: {
            ...product,
            t: {
              [locale]: t(`names.products.${product.name}`),
              pl: t(`names.products.${product.name}`, { lng: "pl" })
            }
          },
          material: {
            ...material,
            t: {
              [locale]: t(`names.materials.${material.name}`),
              pl: t(`names.materials.${material.name}`, { lng: "pl" })
            }
          },
          system: {
            ...system,
            t: {
              [locale]: t(`names.systems.${system.name}`),
              pl: t(`names.systems.${system.name}`, { lng: "pl" })
            }
          },
          type: {
            ...type,
            t: {
              [locale]: t(
                `names.${type.isSubtype ? "subtypes" : "types"}.${type.name}`
              ),
              pl: t(
                `names.${type.isSubtype ? "subtypes" : "types"}.${type.name}`,
                { lng: "pl" }
              )
            }
          },
          ...(hasSingleSideColor(product.id)
            ? {
                color: {
                  ...(color && {
                    ...color,
                    t: {
                      [locale]: t(`names.colors.${color.name}`),
                      pl: t(`names.colors.${color.name}`, { lng: "pl" })
                    }
                  })
                }
              }
            : {
                colorInterior: {
                  ...colorInterior,
                  t: {
                    [locale]: t(`names.colors.${colorInterior.name}`),
                    pl: t(`names.colors.${colorInterior.name}`, { lng: "pl" })
                  }
                },
                colorExterior: {
                  ...colorExterior,
                  t: {
                    [locale]: t(`names.colors.${colorExterior.name}`),
                    pl: t(`names.colors.${colorExterior.name}`, { lng: "pl" })
                  }
                }
              }),
          selectedShades: {
            value: selectedShades,
            t: {
              [locale]: t(`root.${selectedShades ? "yes" : "no"}`),
              pl: t(`root.${selectedShades ? "yes" : "no"}`, { lng: "pl" })
            }
          },
          ...rest
        };

        return item;
      }
    );
};

export const groupItemsByProductId = items => groupBy(items, item => item.productId);

export const hasCategoryType = options =>
  some(options, ({ type }) => type === "category");

export const hasImages = types => some(types, "image");

export const hasShades = id => includes(SHADES_PRODUCT_IDS, id);

export const hasSingleSideColor = id => includes(SINGLE_SIDE_COLOR_PRODUCT_IDS, id);

export default {
  formatSelectedItems,
  groupItemsByProductId,
  hasCategoryType,
  hasImages,
  hasShades,
  hasSingleSideColor
};
